export default __webpack_public_path__ + "static/media/mapMarker.a894424a.svg";